import React, { useContext } from 'react';
import { Moon, Sun } from 'lucide-react';
import { AppSettings } from '../../config/app-settings.js';

export default function ThemeModeToggle() {
  const { appDarkMode, handleSetAppDarkMode } = useContext(AppSettings);
  const isDark = !!appDarkMode;

  return (
    <div className="donezo-theme-toggle" role="group" aria-label="Color theme">
      <button
        type="button"
        className={`donezo-theme-toggle__btn${!isDark ? ' is-active' : ''}`}
        onClick={() => handleSetAppDarkMode(false)}
        aria-pressed={!isDark}
        title="Light mode"
      >
        <Sun size={15} strokeWidth={2.25} aria-hidden />
        <span className="visually-hidden">Light mode</span>
      </button>
      <button
        type="button"
        className={`donezo-theme-toggle__btn${isDark ? ' is-active' : ''}`}
        onClick={() => handleSetAppDarkMode(true)}
        aria-pressed={isDark}
        title="Dark mode"
      >
        <Moon size={15} strokeWidth={2.25} aria-hidden />
        <span className="visually-hidden">Dark mode</span>
      </button>
    </div>
  );
}
